<style lang="less" scoped>
.contanter{
  width: 100%;
  min-width: 1600px;
  height: 382px;
  background-image: url("https://resource.jiupiao.vip/feedback/20231212/17023605920623.png");
  background-size: 100% 382px;
  background-repeat: no-repeat;
  background-position: center;
  .body{
    display: flex;
    width: 1600px;
    margin: 0 auto;
    padding: 95px 0;
    justify-content: center;
    .left{
      text-align: center;
      margin-right: 70px;
      img{
        display: block;
        margin: 0 auto;
      }
      .logo{
        width: 58px;
        height: 52px;
        margin-bottom: 16px;
      }
      .title{
        width: 263px;
        height: 23px;
        margin-bottom: 19px;
      }
      .smtitle{
        width: 209px;
        height: 18px;
        margin-bottom: 19px;
      }
      .list{
        display: flex;
        justify-content: center;
        .icon{
          width: 43px;
          height: 43px;
          margin: 0 4px;
        }
      }
    }
    .right{
      .top{
        display: flex;
        justify-content: left;
        width: 664px;
        border-bottom: 1px solid #75B0D8;
        padding-bottom: 14px;
        .leftBox{
          margin-right: 43px;
          .title{
            color: #75B0D8;
            font-size: 21px;
            font-weight: bold;
          }
          .list{
            color: #fff;
            font-size: 15px;
            line-height: 1.5;
            margin-left: 15px;
          }
          .list::before{
            content: '';
            width: 8px;
            height: 8px;
            background: #75B0D8;
            border-radius: 8px;
            display: block;
            position: relative;
            top: 15px;
            right: 15px;
          }
        }
        .rightBox{
          .title{
            color: #75B0D8;
            font-size: 21px;
            font-weight: bold;
          }
          .code{
            width: 79px;
            height: 79px;
            margin-top: 16px;
          }
        }
      }
      .btm{
        display: flex;
        justify-content: right;
        margin-top: 14px;
        .menu-item{
          margin-left: 39px;
          color: #fff;
          font-weight: bold;
          font-size: 18px;
          .menu-title{
          }
        }
        .active{
          color: #62C2FF!important;
          font-weight: bold;
        }
      }
    }
  }
}
</style>

<template>
  <div class="contanter">
    <div class="body">
      <div class="left">
        <img src="https://resource.jiupiao.vip/feedback/20231212/1702364256816116.png" alt="" class="logo">
        <img src="https://resource.jiupiao.vip/feedback/20231212/1702364266897141.png" alt="" class="title">
        <img src="https://resource.jiupiao.vip/feedback/20231212/170236426978652.png" alt="" class="smtitle">
      </div>
      <div class="right">
        <div class="top">
          <div class="leftBox">
            <div class="title">公司信息</div>
            <div class="list" @click="beian">备案号：陕ICP备2023019783号-1</div>
            <div class="list">陕西省西安市高新区科技三路融城云谷A座1505</div>
            <div class="list">sxw@shuxinwei.com</div>
          </div>
          <div class="rightBox">
            <div class="title">客服企业微信</div>
            <img src="https://resource.jiupiao.vip/feedback/20231212/170236467667437.png" alt="" class="code">
          </div>
        </div>
        <div class="btm">
          <div class="menu-item" v-for="item in page" :key="item" @click="goPage(item.link)">
            <span class="menu-title" :class="{ active: currentPath === item.link }">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import router from "@/router";
import {ref, watchEffect} from "vue";

const page = [
  {
    title: '关于数芯微',
    link: '/',
  },
  {
    title: '公司产业',
    link: '/industry',
  },
  {
    title: '服务体系',
    link: '/service',
  },
  {
    title: '企业文化',
    link: '/culture',
  },
  {
    title: '联系我们',
    link: '/contactUs',
  },
]
const currentPath = ref('');
const goPage = (link) => {
  router.push(link);
  currentPath.value = link;
  console.log(currentPath.value)
}
const beian = () => {
  window.open('https://beian.miit.gov.cn/', '_blank');
}
watchEffect(() => {
  currentPath.value = window.location.pathname;
});
</script>

